export default "__VITE_ASSET__DvPpx19T__"